import { environment } from "../environments/env";
import Api from "./Api";
import { route } from "./routeDictionary";

export default {
  AddHsm(arr) {
        return Api.post(`${environment.apiUrl}${route.AddHsm}`, arr);
    },
}
